'use client'

import { useToast } from '@chakra-ui/react'
import { useCallback } from 'react'

export function useAppToast() {
  const toast = useToast()
  return useCallback(
    (options: Parameters<typeof toast>[0]) => {
      toast({ position: 'bottom-right', ...options, isClosable: true })
    },
    [toast]
  )
}
